// MU
import { Grid } from "@material-ui/core";

// Styles
import { Wrapper } from "./styles";

// Context
// import { useApp } from "../../../../contexts/app";

// Componentes
import Ranking from "./Ranking";

type VisaoProps = {
  procurarTorneio: () => void;
};

export default function VisaoGeral({ procurarTorneio }: VisaoProps) {
  return (
    <Wrapper>
      <Grid container justify="center">
        <Grid container item xs={12} spacing={2} md={8}>
          <Grid container item className="principal">
            <Grid item xs={12} sm={12} className="card-destaque">
              <button onClick={procurarTorneio}>
                <h3>
                  BATALHA<span>DEV</span>
                </h3>
                <p>PRÉ-TEMPORADA ABERTA</p>
                <span>
                  PARTICIPE DE TORNEIOS E RECEBA PRÊMIOS DE ATÉ{" "}
                  <strong>R$1.000,00</strong> POR DIA
                </span>
              </button>
            </Grid>
          </Grid>

          <Grid container item spacing={2} className="secundario">
            <Grid item xs={12} sm={6}>
              <Grid
                container
                item
                className="card-terceiro"
                justify="center"
                alignItems="center"
                alignContent="center"
              >
                <p>
                  Super Promoções: <a href="/recarga">Clique aqui e confira!</a>
                </p>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid
                container
                item
                className="card-secundario"
                justify="center"
                alignItems="center"
                alignContent="center"
              >
                <p>
                  Acelere sua evolução:{" "}
                  <a href="/passe-batalha">Clique aqui e confira!</a>
                </p>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid
                item
                container
                className="card-terceiro"
                justify="center"
                alignItems="center"
                alignContent="center"
              >
                <p>
                  Aprender portugol: <a href="/blog">Clique aqui e confira!</a>
                </p>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid
                item
                container
                className="card-secundario"
                justify="center"
                alignItems="center"
                alignContent="center"
              >
                <p>
                  Aprender técnicas: <a href="/blog">Clique aqui e confira!</a>
                </p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container item md={4}>
          <Ranking />
        </Grid>
      </Grid>
    </Wrapper>
  );
}
